import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@src/store'


export default [
  // 關於零壹
  {
    path: '/about',
    name: 'about',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        next({ name: 'about-zerone' });
      },
      alias: "about",
      title: '關於零壹'
    },
  },
  // 公司簡介
  {
    path: '/about/zerone',
    name: 'about-zerone',
    component: () => lazyLoadView(import('@views/About/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const aboutList  = await store.dispatch('about/fetchAbout')
          routeTo.params.aboutCompany = aboutList.company
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: 'zerone',
      title: '公司簡介'
    },
    props: (route) => ({
      aboutCompany: route.params.aboutCompany || {},
    })
  },
  // 經營團隊
  {
    path: '/about/organization',
    name: 'about-organization',
    component: () => lazyLoadView(import('@views/About/Organization')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const aboutList  = await store.dispatch('about/fetchAbout')
          routeTo.params.aboutTeam = aboutList.team
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: 'organization',
      title: '經營團隊'
    },
    props: (route) => ({
      aboutTeam: route.params.aboutTeam || {},
    })
  },
  // 大事紀
  {
    path: '/about/history',
    name: 'about-history',
    component: () => lazyLoadView(import('@views/About/History')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          routeTo.params.defaultValue = await store.dispatch('global/fetchStaticItem', 'memorabilia')
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: 'history',
      title: '大事紀'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    }),
  },
  // 關於零壹
  {
    path: '/investor',
    name: 'investor',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        next({ name: 'investor-finance' });
      },
      alias: 'investor',
      title: '投資人專區'
    },
  },
  // 財務資訊
  {
    path: '/investor/finance',
    name: 'investor-finance',
    component: () => lazyLoadView(import('@views/AboutInvestor/Finance')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          routeTo.params.defaultValue = await store.dispatch('global/fetchStaticItem', 'finance')
          const [finance, investorList] = await Promise.all([
            store.dispatch('global/fetchStaticItem', 'finance'),
            store.dispatch('about/fetchInvestor'),
          ])
          routeTo.params.defaultValue = finance;
          routeTo.params.investorFinance = investorList.finance
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "finance",
      title: '財務資訊'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      investorFinance: route.params.investorFinance
    }),
  },
  // 股東專欄
  {
    path: '/investor/shareholders',
    name: 'investor-shareholders',
    component: () => lazyLoadView(import('@views/AboutInvestor/Shareholders/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [stockholder, investorList] = await Promise.all([
            store.dispatch('global/fetchStaticItem', 'stockholder'),
            store.dispatch('about/fetchInvestor'),
          ])
          routeTo.params.defaultValue = stockholder;
          routeTo.params.investorStock = investorList.stock
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "shareholders",
      title: '股東專欄'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      investorStock: route.params.investorStock
    }),
  },
  // 公司治理
  {
    path: '/investor/companypolicy',
    name: 'investor-companypolicy',
    component: () => lazyLoadView(import('@views/AboutInvestor/CompanyPolicy')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [rules, investorList] = await Promise.all([
            store.dispatch('global/fetchStaticItem', 'rules'),
            store.dispatch('about/fetchInvestor'),
          ])
          routeTo.params.defaultValue = rules;
          routeTo.params.investorCompany = investorList.company
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "companypolicy",
      title: '公司治理'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      investorCompany: route.params.investorCompany
    }),
  },
  // 利害關係人專區
  {
    path: '/investor/int',
    name: 'investor-int',
    component: () => lazyLoadView(import('@views/AboutInvestor/Int')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const investorList = await store.dispatch('about/fetchInvestor')
          routeTo.params.investorRelation = investorList.relation
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "int",
      title: '利害關係人專區'
    },
    props: (route) => ({
      investorRelation: route.params.investorRelation,
    }),
  },
  // 關於零壹 手機版選單
  {
    path: '/about/menu',
    name: 'about-menu',
    component: () => lazyLoadView(import('@views/MobilePageMenu/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const vw = document.body.clientWidth 
          if(vw > 676) {
            next({ name: 'about-zerone' });
          }
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "about",
      title: '關於零壹'      
    },
  },
]
